/** Shared stage vocabulary. Transition permissions stay in the server domain. */
const requestEntries = [
  ['REQUESTED', 'Talep alındı'], ['DISCUSSING', 'Görüşülüyor'], ['PREPARING', 'Teklif hazırlanıyor'],
  ['SENT', 'Teklif iletildi'], ['PROCUREMENT', 'Satın alma yürütülüyor'], ['DELIVERING', 'Uygulama sürüyor'],
  ['COMPLETED', 'Tamamlandı'], ['NOT_PROCEEDING', 'İlerlemedi'], ['CANCELLED', 'İptal edildi'],
];
export const REQUEST_STAGES = Object.freeze(requestEntries.map(([id, label]) => Object.freeze({ id, label })));
export const COLLECTION_STAGES = Object.freeze([Object.freeze({ id: 'RECOMMENDED', label: 'Önerildi' }), ...REQUEST_STAGES]);
export const REQUEST_STAGE_IDS = Object.freeze(REQUEST_STAGES.map(stage => stage.id));
export const COLLECTION_STAGE_IDS = Object.freeze(COLLECTION_STAGES.map(stage => stage.id));
export const STAGE_LABELS = Object.freeze(Object.fromEntries(COLLECTION_STAGES.map(stage => [stage.id, stage.label])));
export const TERMINAL_STAGE_IDS = Object.freeze(['COMPLETED', 'NOT_PROCEEDING', 'CANCELLED']);
export const terminalStages = new Set(TERMINAL_STAGE_IDS);
export const orderedStages = REQUEST_STAGE_IDS;
